import React from "react";
import moment from "moment";
import momentTimezone from "moment-timezone";

const DateTimeLabel = ({ startDate, startTime, timezone }) => {
  // Parse datetime based on timezone
  const dateTime = timezone
    ? momentTimezone.tz(`${startDate} ${startTime}`, timezone)
    : moment.utc(`${startDate} ${startTime}`);

  const now = timezone ? momentTimezone().tz(timezone) : moment.utc();

  const formattedDate = dateTime.format("MM/DD/YYYY");
  const time = dateTime.format("hh:mm a (z)");

  let dateLabel = formattedDate;
  if (dateTime.isSame(now, "day")) {
    dateLabel = "TODAY";
  } else if (
    dateTime.clone().startOf("day").diff(now.clone().startOf("day"), "days") ===
    1
  ) {
    dateLabel = "TOMORROW";
  }

  return (
    <>
      {dateLabel}
      <br />
      {time}
    </>
  );
};

export default DateTimeLabel;
